<template>
    <div class="user">
        <div class="product-content">
            <div class="common-seach-wrap">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">

                    <el-form-item label="拼团状态">
                        <el-select v-model="formInline.grade_id" placeholder="请选择">
                            <el-option label="全部" value="0"></el-option>
                            <el-option v-for="(item,index) in gradeList" :key="index" :label="item.name"
                                       :value="item.grade_id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="拼团名称">
                        <el-input v-model="formInline.nick_name" placeholder="请输入拼团名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="common-level-rail">
                <el-button type="primary" @click="addClick">新增拼团</el-button>
            </div>
            <div class="product-content">
                <el-form ref="form" :model="form" label-width="100px">
                    <div class="table-wrap">
                        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
                            <el-table-column prop="title" label="拼团名称"></el-table-column>
                            <el-table-column prop="image_id" label="活动图片"></el-table-column>
                            <el-table-column prop="start_time" label="开始时间"></el-table-column>
                            <el-table-column prop="end_time" label="结束时间"></el-table-column>
                            <el-table-column prop="active_time_count" label="订单数"></el-table-column>
                            <el-table-column prop="status" label="状态"></el-table-column>
                            <el-table-column fixed="right" label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                                    <el-button @click="deleteClick(scope.row)" type="text" size="small">查看商品</el-button>
                                    <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
                <!--分页-->
                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                                   :current-page="curPage"
                                   :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="totalDataNumber">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SharingApi from '@/api/sharing.js';
    export default {
        components: {},
        inject: ['reload'],
        data() {
            return {
                /*是否加载完成*/
                loading: true,
                /*列表数据*/
                tableData: [],
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                form: {},
                formInline: {},
                gradeList: {},
                /*是否打开添加弹窗*/
                open_add: false,
                /*是否打开编辑弹窗*/
                open_edit: false,
                /*当前编辑的对象*/
                userModel: {}
            };
        },
        created() {
            /*获取列表*/
            this.getTableList();

        },
        methods: {
            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.getTableList();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.pageSize = val;
                this.getTableList();
            },

            /*获取列表*/
            getTableList() {
                let self = this;
                let Params = {};
                SharingApi.activeList(Params, true)
                    .then(data =>
                    {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total
                    })
                    .catch(error =>
                    {
                        self.loading = false;
                    });
            },

            /*搜索查询*/
            onSubmit() {
                this.$message('这是一条消息提示');
            },
            /*打开添加*/
            addClick() {
                this.$router.push('/plus/sharing/add');
            },
            /*删除*/
            deleteClick(row) {
                let self = this;
                self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() =>
                {
                    self.loading = true;
                    StoreApi.deleteShop({
                        shop_id: row.shop_id
                    }, true)
                        .then(data =>
                        {
                            self.loading = false;
                            if (data.code == 1) {
                                self.$message({
                                    message: '恭喜你，门店删除成功',
                                    type: 'success'
                                });
                            }
                            self.getTableList();
                        })
                        .catch(error =>
                        {
                            self.loading = false;
                        });

                }).catch(() =>
                {

                });
            }

        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/sharing/index.vue